/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useUpdateGcpAccountCredentialsMutation,
  UpdateGcpAccountCredentialsInput,
} from "~/generated/graphql";
import { Provider } from "../../types";
import { UpdateHandlerVariables } from "../types";

export function useUpdateGcpAccountCredentials() {
  const [updateGcpCredentials, ...mutationState] =
    useUpdateGcpAccountCredentialsMutation();

  const handleGcpCredentialsUpdate = async (
    variables: UpdateHandlerVariables<Provider.Gcp>,
    selectedNid: string
  ) => {
    const { key } = variables;

    await updateGcpCredentials({
      variables: {
        id: selectedNid,
        input: JSON.parse(key) as UpdateGcpAccountCredentialsInput,
      },
    });
  };

  return [handleGcpCredentialsUpdate, mutationState] as const;
}
